<template>
    <div class="rd">
        <div class="pagina">
            <header class="paginakop">
                <div class="tekst">
                    <nav class="kruimel" aria-label="Breadcrumb">
                        <router-link :to="{ name: 'bookings' }">Bookings</router-link>
                        <span>/</span>
                        <span>New</span>
                    </nav>
                    <h1>New booking</h1>
                    <p>For phone bookings and walk-ins. The customer gets the door code by email.</p>
                </div>
            </header>
            <booking-form :locations="locations" v-model="booking">
                <button class="btn btn-pink" type="button" :disabled="loading" @click="saveBooking">
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><path d="m5 12.5 4.5 4.5L19 7.5" /></svg>
                    {{ loading ? "Creating booking…" : "Create booking" }}
                </button>
                <p v-if="customerMailsDisabled" class="melding fout">No email goes to the customer for this location. Share the door code yourself.</p>
                <p v-else class="melding">We email the door code to the customer.</p>
            </booking-form>
        </div>
    </div>
</template>

<script setup>
import { Message } from "element-ui";
import { computed, onMounted, ref } from "vue";
import * as Sentry from "@sentry/vue";
import { getUserLocationsSimple } from "../../api/graphql/locations";
import { createBooking } from "../../api/rest";
import { useRouter } from "vue-router/composables";
import BookingForm from "../booking/BookingForm.vue";

const loading = ref(false);
const locations = ref([]);

const router = useRouter();

const createEmptyBooking = () => {
    let uuid = new Date().getTime();
    if (self.crypto.randomUUID) {
        uuid = self.crypto.randomUUID();
    }
    const code = `HUB-${uuid}`;
    return {
        code,
        name: "",
        email: "",
        team_1_name: "",
        team_1_size: 1,
        language: "nl",
        xcube_id: null,
        experience_id: null,
        phone_number: "",
        event_datetime: new Date(),
    };
};

const booking = ref(createEmptyBooking());

// The ticket note flips to a warning when the chosen location is configured to
// send no customer mail; staff then share the door code themselves.
const selectedLocation = computed(() =>
    locations.value.find((loc) => loc.xcubes.some((x) => x.id === booking.value.xcube_id)),
);
const customerMailsDisabled = computed(() => !!selectedLocation.value?.disable_customer_mails);

onMounted(async () => {
    locations.value = await getUserLocationsSimple();
});

const saveBooking = async () => {

    const saveData = {
        ...booking.value,
        event_datetime: booking.value.event_datetime,
        xcube_id: Number.parseInt(booking.value.xcube_id),
        experience_id: Number.parseInt(booking.value.experience_id),
    }

    try {
        loading.value = true;
        const newBooking = await createBooking(saveData);
        Message.success({ message: "Booking Created" });
        router.push({ name: 'view-booking', params: { id: newBooking.id } });
    } catch (e) {
        Message.error({ message: `Error creating booking: ${e.message}` });
        Sentry.captureException(e);
    } finally {
        loading.value = false;
    }
};
</script>
